module.exports = ".dashboard-component {\n    border: 15px solid grey;\n    border-radius: 4px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.css
// module id = ./src/app/dashboard/dashboard.component.css
// module chunks = main